import { faEdit } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import InvestmentsCardView from "../../../components/InvestmentsCardView";
//import { OPTIONS_DATA_MAPPER } from "../../utils";
//import AddToolTip from "../AddToolTip";

const SourceSplitupContainer = (props) => {
  const { data, values, module, overnightDelivery } = props;
  const totalFees = () => {
    if (module == "loans") {
      let fees = 0;
      fees += data?.loanFeeAmount;
      if (values?.paymentOption == 2 || values?.paymentMethod == 2)
        fees += data?.eftFees;
      if (values?.paymentOption == 1 || values?.paymentMethod == 1)
        fees += data?.chequeFees;
      if (overnightDelivery) fees += data?.overnightDeliveryFees;
      return fees;
    }
  };

  console.log("data123", values, data);

  return (
    <>
      <div className="SourceSplitUp-card">
        <div className="source-flex-column">
          <p className="Investment-heading">Balance</p>
          <p className="Investment-value">
            ${" "}
            {(data?.sourceAccountBalance ?? 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>
        <div className="Investment-horizontal-bar">
          <p className="Investment-heading">Net Request Amount</p>
          <p className="Investment-value">
            ${" "}
            {(data?.requestedAmount ?? 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>
        <div className="Investment-horizontal-bar">
          <p className="Investment-heading">Gross Loan Amount</p>
          <p className="Investment-value">
            ${" "}
            {(data?.grossWithdrawalAmount ?? 0).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>
        <div className="Investment-horizontal-bar">
          <p className="Investment-heading">Investments</p>
          <p className="Investment-value">
            {data?.sourceInvestmentBalances?.length ?? 0}
          </p>
        </div>
        {module == "loans" && (
          <div className="Investment-horizontal-bar">
            <p className="Investment-heading">Fees</p>
            <p className="Investment-value">
              {(totalFees() ?? 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
        )}
      </div>
      {module == "loans" && (
        <div className="source-padding-right mb-1">
          <p className="source-investmentment-headding">Tax, fee & penalty </p>
          <div className="tax-fee-penalty-container">
            <p className="head">TPA Fee</p>
            <p className="value">
              ${" "}
              {(data?.loanFeeAmount ?? 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
          <div className="tax-fee-penalty-container">
            {values.paymentMethod == 2 || values.paymentOption == 2 ? (
              <>
                <p className="head">EFT Fee</p>
                <p className="value">
                  ${" "}
                  {(data?.eftFees ?? 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </>
            ) : (
              <>
                <p className="head">Check Fee</p>
                <p className="value">
                  ${" "}
                  {(data?.chequeFees ?? 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </>
            )}
          </div>

          <div className="tax-fee-penalty-container">
            <p className="value">Total</p>
            <p className="value">
              ${" "}
              {(
                data?.grossWithdrawalAmount - data?.requestedAmount ?? 0
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
        </div>
      )}
      {module == "distribution" && (
        <div className="source-padding-right">
          <p className="source-investmentment-headding">Tax, Fee & Penalty </p>
          <div className="tax-fee-penalty-container">
            {values.distributionMode == 1 ? (
              <>
                <p className="head">Withdrawal Fee</p>
                <p className="value">
                  ${" "}
                  {(data?.withdrawalFee ?? 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </>
            ) : (
              <>
                <p className="head">RollOver Fee</p>
                <p className="value">
                  ${" "}
                  {(data?.rollOverFee ?? 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </>
            )}
          </div>
          <div className="tax-fee-penalty-container">
            {values.paymentMethod == 2 ? (
              <>
                <p className="head">EFT Fee</p>
                <p className="value">
                  ${" "}
                  {(data?.eftFee ?? 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </>
            ) : (
              <>
                <p className="head">Check Fee</p>
                <p className="value">
                  ${" "}
                  {(data?.checkFee ?? 0).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </>
            )}
          </div>
          <div className="tax-fee-penalty-container">
            <p className="head">Federal Tax</p>
            <p className="value">
              ${" "}
              {data?.federalTax?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
          <div className="tax-fee-penalty-container">
            <p className="head">State Tax</p>
            <p className="value">
              ${" "}
              {data?.stateTax?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
          <div className="tax-fee-penalty-container dashed-line">
            <p className="head">Penalty</p>
            <p className="value">
              ${" "}
              {data?.earlyWithdrawalPenalty?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) ?? 0}
            </p>
          </div>
          <div className="tax-fee-penalty-container">
            <p className="value">Total</p>
            <p className="value">
              ${" "}
              {(
                data?.grossWithdrawalAmount - data?.requestedAmount ?? 0
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
        </div>
      )}
      <div className="sorce-padding">
        <p className="source-investmentment-headding">Investments</p>
        <InvestmentsCardView data={data?.sourceInvestmentBalances} />
      </div>
    </>
  );
};

export default SourceSplitupContainer;
